import { buildUserIdPayload } from '../utils/userIdPayload';

export async function enter_chat({ platform, userId, contract_number }) {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/chats/enter_chat`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...buildUserIdPayload(platform, userId),
            contract_number
        })
    });
    return (await response.json())?.result;
}
